import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../components/login'
import adminList from '../components/admin/adminList'
import companyList from '../components/admin/companyList'
import menusVue from '../components/admin/menus.vue'
import roleVue from '../components/admin/role.vue'

Vue.use(VueRouter);

export const routes = [

  
  {
    path: '/menu',
    name: 'menu',
    meta:{
      isLogin:true
    },
    
    component: () => import('../components/menu'),
    children:[
      {
        path:'',
        name:'dash',
        meta:{
          isLogin:true
        },
        component:() => import('@/components/home')
      },

      {
        path:'question',
        name:'question',
        meta:{
          isLogin:true
        },
        component:() => import('../components/question')
		
      },
      {
        path:'getReport',
        name:'getReport',
        meta:{
          isLogin:true
        },
        component:() => import('../components/getReport')
      },
      {
        path:'bookingInfo',
        name:'bookingInfo',
        meta:{
          isLogin:true
        },
        component:() => import('../components/bookingInfo')
      },
      {
        path:'resultUpload',
        name:'resultUpload',
        meta:{
          isLogin:true
        },
        component:() => import('../components/resultUpload')
      },
      {
        path:'getVaccin',
        name:'getVaccin',
        meta:{
          isLogin:true
        },
        component:() => import('../components/vaccin')
      },
      {
        path:'goodslist',
        name:'goodslist',
        meta:{
          isLogin:true
        },
        component:() => import('../components/goodslist'),
      },
      {
        path:'discount',
        name:'discount',
        meta:{
          isLogin:true
        },
        component:() => import('../components/discount'),
      },
      {
        path:'question',
        name:'question',
        meta:{
          isLogin:true
        },
        component:() => import('../components/question')
		
      },
      {
        path:'goods',
        name:'goods',
        meta:{
          isLogin:true
        },
        component:() => import('../components/goods'),
      },
      {
        path:'feedback',
        name:'feedback',
        meta:{
          isLogin:true
        },
        component:() => import('../components/feedback'),
      },
      {
        path:'order',
        name:'order',
        meta:{
          isLogin:true
        },
        component:() => import('../components/order'),
      },
	  {
	    path: 'adminList',
	    name: '管理员列表',
	    meta:{
	      isLogin:true
	    },
		component:adminList
	  },
	  {
	    path: 'companyList',
	    name: '企业管理',
	    meta:{
	      isLogin:true
	    },
		component:companyList
	  },
	  
	  {
	    path: 'menus',
	    name: '菜单管理',
	    meta:{
	      isLogin:true
	    },
		component:menusVue
	  },
	  {
	    path: 'role',
	    name: '角色管理',
	    meta:{
	      isLogin:true
	    },
		component:roleVue
	  },
    ]
  },
  
];


export const defaultRoutes = [
	{
	  path: '/',
	  name: 'login',
	  component: login
	},
	{
	  path: '/menu',
	  name: 'menu',
	  meta:{
	    isLogin:true
	  },
	  component: () => import('../components/menu'),
		children:[
			{
			  path:'',
			  name:'dash',
			  meta:{
			    isLogin:true
			  },
			  component:() => import('@/components/home')
			},
		]
	},
	  
	{
	  path: "/404",
	  name: "404",
	  meta: {
	    title: '404'
	  },
	  component:() => import('@/components/error')
	},
	{
	  path: "*",
	  redirect: "/menu"
	}
]

const router = new VueRouter({
  routes:defaultRoutes
});

export default router
